<template>
  <v-layout justify-center>
    <v-dialog
      v-model="verifying_email_dialog"
      persistent
      max-width="600"
    >
      <v-card style="height: 250px">
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>
            One Moment Please While We Verify Your Email...
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="text-center">
          <v-progress-circular
            :size="100"
            :width="7"
            color="primary"
            indeterminate
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card
      v-if="verifying_email_success"
      class="padding: 3%;"
    >
      <v-toolbar
        dark
        color="success"
      >
        <v-toolbar-title>
          Your email address has been successfully verified.
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        Thank you for completing your registration. You will now be redirected
        back to the login page.
      </v-card-text>
    </v-card>
    <v-card
      v-if="verifying_email_failed"
      class="padding: 3%;"
    >
      <v-toolbar
        dark
        color="error"
      >
        <v-toolbar-title>
          We were unable to verify your email address.
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>Something went wrong.</v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
const sleep = m => new Promise(r => setTimeout(r, m));
export default {
  data() {
    return {
      verifying_email_dialog: true,
      verifying_email_success: false,
      verifying_email_failed: false,
      key: ""
    };
  },
  computed: {
    ...mapState({
      email_verified: state => state.auth.email_verified
    })
  },
  watch: {
    async email_verified() {
      if (this.email_verified) {
        this.verifying_email_dialog = false;
        this.verifying_email_success = true;
        await sleep(3000);
        this.$router.push("/login/");
      } else {
        this.verifying_email_dialog = false;
        this.verifying_email_failed = true;
        await sleep(3000);
        this.$router.push("/login/");
      }
    }
  },
  async created() {
    this.parseURL();
    await sleep(3000);
    this.confirmEmail(this.key);
  },
  methods: {
    ...mapActions("auth", ["confirmEmail"]),
    parseURL() {
      this.key = this.$route.params.pathMatch.slice(0, -1);
    }
  }
};
</script>
